export const targetBaseUrl = "https://api.int.platform.indexar.tech"



// WEBPACK FOOTER //
// ./src/apiconfig.js